import styled from "styled-components";

export const LocationSubTitle = styled.div`
  color: var(--vds-elements-text-icons-borders-primary-onlight, #000);
  font-feature-settings: "clig" off, "liga" off;
  font-family: Verizon NHG TX;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

export const LocationTitle = styled.div`
  color: var(--vds-elements-text-icons-borders-primary-onlight, #000);
  font-feature-settings: "clig" off, "liga" off;
  font-family: Verizon NHG TX;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;
  display: inline;
`;

export const LocationContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const Title = styled.div`
  color: var(--vds-elements-text-icons-borders-primary-onlight, #000);
  font-feature-settings: "clig" off, "liga" off;
  font-family: Verizon NHG DS;
  font-size: 32px;
  font-style: normal;
  font-weight: 300;
  line-height: 36px;
  letter-spacing: 0.25px;
  padding-top: 32px;
  padding-bottom: 32px;
`;

export const Container = styled.div`
  margin-top: 32px;
  display: flex;
  border-top: 1px solid var(--vds-palette-gray-85, #d8dada);
  border-bottom: 1px solid var(--vds-palette-gray-85, #d8dada);
`;

export const FloorPlanContainer = styled.div`
  width: 40%;
  heigth: 800px;
  overflow: hidden;
  border-left: 1px solid var(--vds-palette-gray-85, #d8dada);
  background: var(--vds-background-secondary-light, #f6f6f6);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ContentContainer = styled.div`
  display: flex;
  width: 60%;
  heigth: 800px;
  overflow: scroll;
  flex-direction: column;
  align-items: flex-start;
  margin-right: 32px;
`;

export const HeaderContentRow = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid var(--vds-palette-gray-85, #000000);
  height: 40px;
  align-items: center;
  width: 100%;
`;

export const ContentRow = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid var(--vds-palette-gray-85, #d8dada);
  height: 40px;
  align-items: center;
  width: 100%;
  &:hover {
    background: var(--vds-feedback-information-background-onlight, #e3f2fd);
  }
`;

export const TotalContentRow = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid var(--vds-palette-gray-85, #d8dada);
  border-left: 1px solid var(--vds-palette-gray-85, #d8dada);
  border-right: 1px solid var(--vds-palette-gray-85, #d8dada);
  background: var(--vds-background-secondary-light, #f6f6f6);
  height: 40px;
  align-items: center;
  width: 100%;
`;

export const HeaderContentBox = styled.div`
  width: 150px;
  color: var(--vds-elements-text-icons-borders-primary-onlight, #000);
  font-feature-settings: "clig" off, "liga" off;
  font-family: Verizon NHG DS;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  margin-left: 5px;
  display: flex;
`;

export const ContentBox = styled.div`
  width: 150px;
  color: var(--vds-elements-text-icons-borders-primary-onlight, #000);
  font-feature-settings: "clig" off, "liga" off;
  font-family: Verizon NHG TX;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  margin-left: 5px;
  cursor: pointer;
`;

export const TotalContentBox = styled.div`
  width: 150px;
  color: var(--vds-elements-text-icons-borders-primary-onlight, #000);
  background: var(--vds-background-secondary-light, #f6f6f6);
  font-feature-settings: "clig" off, "liga" off;
  font-family: Verizon NHG DS;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  margin-left: 5px;
`;

export const ImageStyle = styled.img`
  width: 100%;
  height: 100%;
`;

export const ImageContainer = styled.div`
  width: 16px;
  height: 16px;
  margin-left: 4px;
  cursor: pointer;
`;

export const ModalTitle = styled.div`
  color: var(--vds-elements-text-icons-borders-primary-onlight, #000);
  font-feature-settings: "clig" off, "liga" off;
  font-family: Verizon NHG DS;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px;
`;

export const ModalDetailsContainer = styled.div`
  display: flex;
  width: 1200px;
  padding-top: 10px;
  paddind-left: 48px;
  flex-direction: column;
`;

export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const DetailsTitleContainer = styled.div`
  display: flex;
`;

export const DetailsTitle = styled.div`
  color: var(--vds-elements-text-icons-borders-primary-onlight, #000);
  font-feature-settings: "clig" off, "liga" off;
  font-family: Verizon NHG DS;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 120% */
  padding: 4px;
  border-color: #fe0404;
`;

export const DetailsRow = styled.div`
  display: flex;
  padding: var(--space-6-x, 24px) 0px;
  flex-direction: column;
  justify-content: center;
  gap: var(--space-3-x, 12px);
  align-self: stretch;
  width: 328px;
  height: 80px;
  border-bottom: 1px solid var(--vds-palette-gray-85, #d8dada);
  border-top: 1px solid var(--vds-palette-gray-85, #d8dada);
`;

export const DetailsRowTitle = styled.div`
  color: var(--vds-elements-text-icons-borders-secondary-onlight, #6f7171);
  font-feature-settings: "clig" off, "liga" off;
  font-family: Verizon NHG TX;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

export const DetailsRowStat = styled.div`
  color: var(--vds-elements-text-icons-borders-primary-onlight, #000);
  font-feature-settings: "clig" off, "liga" off;
  font-family: Verizon NHG DS;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 125% */
`;

export const LiveFeedContainer = styled.div`
  display: flex;
  width: 100%;
  height: 400px;
  align-items: baseline;
  justify-content: space-around;
`;

export const VideoBox = styled.div`
  width: 100%;
`;

export const videoContainer = styled.div`
  width: 875px;
  border-radius: 8px;
  background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.5) 0%,
      rgba(0, 0, 0, 0.5) 100%
    ),
    url(<path-to-image>), lightgray 50% / cover no-repeat;
  margin-left: 10px;
`;

export const ImageStyle2 = styled.img`
  width: 92%;
  height: 90%;
`;

export const NoDataContainer = styled.div`
  display: flex;
  padding: 80px 0px;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: var(--space-8-x, 32px);
  flex: 1 0 0;
`;

export const NoDataText = styled.div`
  color: var(--vds-elements-text-icons-borders-primary-onlight, #000);
  font-family: Verizon NHG DS;
  font-size: 32px;
  font-style: normal;
  font-weight: 300;
  line-height: 36px; /* 112.5% */
`;

export const RightAlignedButton = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-left: auto;
  gap: 10px;
`;
